import { Currency, DemeterSymbolContractModel, DemeterSymbolModel, UnitOfMeasure } from '../../../../Generated/Raven-Demeter';

export enum LineSeriesSpreadType {
    Projection = 'projection',
    ThisYear = 'thisYear',
    LastYear = 'lastYear',
    PreviousYearsAverage = 'previousYearsAverage',
}

export interface ICalendarSpreadSelections {
    symbol1: DemeterSymbolModel;
    contracts1: DemeterSymbolContractModel[];
    contract1: DemeterSymbolContractModel;
    symbol2: DemeterSymbolModel;
    contracts2: DemeterSymbolContractModel[];
    contract2: DemeterSymbolContractModel;
    currency: Currency;
    unitOfMeasure: UnitOfMeasure;
}

export interface ICalendarSpreadPeriodCalculation {
    average?: number;
    deciles?: number[];
}

export interface ICalendarSpreadCalculationResult {
    contract1?: ICalendarSpreadPeriodCalculation;
    contract2?: ICalendarSpreadPeriodCalculation;
    threeMonths?: ICalendarSpreadPeriodCalculation;
    sixMonths?: ICalendarSpreadPeriodCalculation;
    nineMonths?: ICalendarSpreadPeriodCalculation;
    twelveMonths?: ICalendarSpreadPeriodCalculation;
}

export const spreadCurrencies = [Currency.Usd, Currency.Eur, Currency.Gbp, Currency.Brl];

export const dairySpreadUnitOfMeasures: UnitOfMeasure[] = [
    UnitOfMeasure.HundredWeight,
    UnitOfMeasure.Kilogram,
    UnitOfMeasure.MetricTon,
    UnitOfMeasure.Pound,
    UnitOfMeasure.ShortTon,
];
export const energySpreadUnitOfMeasures: UnitOfMeasure[] = [
    UnitOfMeasure.Gallon,
    UnitOfMeasure.Barrel,
    UnitOfMeasure.MegaWattHour,
    UnitOfMeasure.MillionBritishThermalUnits,
];

export interface ICalendarAverageAnchor {
    masterAsOfDate: Date;
    contracts: ICalendarSpreadEntriesByDate[];
}

export interface ICalendarSpreadEntriesByDate {
    masterAsOfDate: Date;
    contract1AsOfDate: Date | null;
    contract2AsOfDate: Date | null;
    yearNumber: number;
    contract1ReutersInstrumentCode: string | null;
    contract1Price: number | null;
    contract2ReutersInstrumentCode: string | null;
    contract2Price: number | null;
    spread: number | null;
}
